import {
  MODAL_CREATE_LEAD_FORM_PROFILE_CITY,
  MODAL_CREATE_LEAD_FORM_PROFILE_COMPANY,
  MODAL_CREATE_LEAD_FORM_PROFILE_COUNTRY,
  MODAL_CREATE_LEAD_FORM_PROFILE_EMAIL,
  MODAL_CREATE_LEAD_FORM_PROFILE_FIRST_NAME,
  MODAL_CREATE_LEAD_FORM_PROFILE_JOB_TITLE,
  MODAL_CREATE_LEAD_FORM_PROFILE_LAST_NAME,
  MODAL_CREATE_LEAD_FORM_PROFILE_LINKEDIN,
  MODAL_CREATE_LEAD_FORM_PROFILE_PHONE,
  MODAL_CREATE_LEAD_FORM_PROFILE_STATE,
  MODAL_CREATE_LEAD_FORM_PROFILE_ZIP,
} from "../i18n/keysTranslations.js";

export const LINKEDIN_LEAD_FORM_PROFILE_FIELD_OPTIONS = [
  { value: "FIRST_NAME", label: MODAL_CREATE_LEAD_FORM_PROFILE_FIRST_NAME },
  { value: "LAST_NAME", label: MODAL_CREATE_LEAD_FORM_PROFILE_LAST_NAME },
  { value: "EMAIL", label: MODAL_CREATE_LEAD_FORM_PROFILE_EMAIL },
  { value: "PHONE_NUMBER", label: MODAL_CREATE_LEAD_FORM_PROFILE_PHONE },
  { value: "CITY", label: MODAL_CREATE_LEAD_FORM_PROFILE_CITY },
  { value: "STATE", label: MODAL_CREATE_LEAD_FORM_PROFILE_STATE },
  { value: "COUNTRY", label: MODAL_CREATE_LEAD_FORM_PROFILE_COUNTRY },
  { value: "ZIP_CODE", label: MODAL_CREATE_LEAD_FORM_PROFILE_ZIP },
  { value: "JOB_TITLE", label: MODAL_CREATE_LEAD_FORM_PROFILE_JOB_TITLE },
  { value: "COMPANY_NAME", label: MODAL_CREATE_LEAD_FORM_PROFILE_COMPANY },
  {
    value: "LINKEDIN_PROFILE_LINK",
    label: MODAL_CREATE_LEAD_FORM_PROFILE_LINKEDIN,
  },
];
